(function (){
    'use strict';

    angular
        .module('news', [
            'ui.router',
            'ui.bootstrap',
            'ngDialog',
            'ui.select',
            'ngSanitize',
            'vAccordion',
            'ngAnimate',
            'ui.footable',
            'summernote',
            'validation'
        ]);
})();